import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 48C4C59F-80F3-454B-94B2-1951506F38C1
 * name alphabet-tengwar
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabet-tengwar.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetTengwarIcon = createSvgIcon(<><path d="M10 7L12.5 3H15L11 7H10M12.5 9C11.96 9 11.46 9.13 11 9.35V9H8V11H9V21H11V12.5C11 11.67 11.67 11 12.5 11C13.33 11 14 11.67 14 12.5V14.5C14 15.33 13.33 16 12.5 16H12V18H12.5C14.43 18 16 16.43 16 14.5V12.5C16 10.57 14.43 9 12.5 9Z" /></>, 'AlphabetTengwarIcon');
export default AlphabetTengwarIcon